import SuperAgentInformation from './ShowInformation/SuperAgent.information';
import CompanyInformation    from './ShowInformation/Company.information'   ;
import ManagerInformation    from './ShowInformation/Manager.information'   ;
import ApproveDocuments      from './ApproveDocuments'                      ;
import ShowDrivers           from './ShowDrivers'                           ;
import PayDeposit            from './PayDeposit'                            ;
import Favorite              from './Favorite'                              ;
import Approve               from './Approve'                               ;
import Search                from './Search'                                ;
import Filter                from './Filter'                                ;
import Create                from './Create'                                ;
import Update                from './Update'                                ;
import Body                  from './Body'                                  ;

const Components = {
  SuperAgentInformation,
  CompanyInformation   ,
  ManagerInformation   ,
  ApproveDocuments     ,
  ShowDrivers          ,
  PayDeposit           ,
  Favorite             ,
  Approve              ,
  Search               ,
  Filter               ,
  Create               ,
  Update               ,
  Body                 ,
};

export default Components;
